import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UserAgreementsEntity } from '@monsido/modules/models/api/interfaces/user.interface';
import { User } from '@monsido/modules/models/api/user';
import { TableModule, IconsModule } from '@monsido/angular-shared-components';
import { CommonModule } from '@angular/common';
import { CustomerInterface } from '@monsido/modules/models/api/interfaces/customer.interface';
import { TranslateModule } from 'app/modules/translate.module';

@Component({
    selector: 'mon-sudo-button',
    templateUrl: 'sudo-button.html',
    styleUrls: ['./sudo-button.component.scss'],
    imports: [CommonModule, TableModule, TranslateModule, IconsModule],
})
export class SudoButtonComponent {
    @Output() sudoEvent = new EventEmitter();
    @Input() user: User;
    @Input() customer: CustomerInterface;

    constructor () {}

    customerAgreements (): UserAgreementsEntity[] {
        if (this.user && Array.isArray(this.user.user_agreements)) {
            return this.user.user_agreements.filter((agreement) => {
                return agreement.account && agreement.account.type === 'Customer';
            });
        }

        return [];
    }

    sudo (customerId: number, user: User): void {
        this.sudoEvent.emit({ customerId, user });
    }

    sudoWithCustomer = (): void => {
        this.sudo(this.customer.id, this.user);
    };

    sudoWithFirstAgreement = (): void => {
        const firstAgreement = this.customerAgreements()[0];
        if (firstAgreement) {
            this.sudo(firstAgreement.account.id, this.user);
        }
    };

    isApiUser (): boolean {
        return this.user?.api_user === true;
    }
}
